import React from 'react';
import { Flex } from 'antd';
import { ArrowRight, ArrowLeft } from '../assets/icons/icons';

interface AlertsNavButtonsProps {
  alertsArrayLength: number;
  alertIndex: number;
  setAlertIndex: (index: number) => void;
  index: number;
}

const AlertsNavButtons: React.FC<AlertsNavButtonsProps> = ({
  alertsArrayLength,
  alertIndex,
  setAlertIndex,
  index,
}) => {
  return (
    <Flex
      justify='space-between'
      align='center'
      className='custom-card-drawer-header shipment-alerts-wrapper'
    >
      <p className='issues-text'>
        {alertIndex + 1} of {alertsArrayLength} issues
      </p>
      <Flex
        gap={8}
        align='center'
        className='custom-card-drawer-header-actions'
      >
        <button
          className='nav-arrow-btn'
          // eslint-disable-next-line react/forbid-dom-props
          style={{
            cursor: index === 0 ? 'not-allowed' : 'pointer',
          }}
          title='Previous Alert'
          onClick={() => {
            if (alertIndex > 0) {
              setAlertIndex(alertIndex - 1); // Decrease the alertIndex by 1
            }
          }}
        >
          <ArrowLeft
            fill={index === 0 ? 'var(--text-tertiary)' : 'var(--text-primary)'}
          />
        </button>

        <button
          className='nav-arrow-btn'
          // eslint-disable-next-line react/forbid-dom-props
          style={{
            cursor: index === alertsArrayLength - 1 ? 'not-allowed' : 'pointer',
          }}
          title='Next Alert'
          onClick={() => {
            if (alertIndex < alertsArrayLength - 1) {
              setAlertIndex(alertIndex + 1); // Decrease the alertIndex by 1
            }
          }}
        >
          <ArrowRight
            fill={
              index === alertsArrayLength - 1
                ? 'var(--text-tertiary)'
                : 'var(--text-primary)'
            }
          />
        </button>
      </Flex>
    </Flex>
  );
};

export default AlertsNavButtons;
